import bannersModule, { BannerTypes } from '@gin-betting/banners';
import type { GQL } from '@gin-betting/core';
import { sortBy } from 'lodash';
import { createSelector } from 'reselect';

const {
    selectors: { makeSelectBannerZonesByAttributes, selectZoneBanners },
} = bannersModule;

export type BannersTuples = Array<[string, BannerTypes.BannerItem[]]>;

interface MakePropsSelectorOutput {
    banners: BannersTuples;
    zones: GQL.BannerZone[];
}

export const makePropsSelector = (
    zoneLocation: BannerTypes.BannerZoneLocation
) => {
    return createSelector(
        makeSelectBannerZonesByAttributes([{ pageLocation: zoneLocation }]),
        selectZoneBanners,
        (zones, bannerZone): MakePropsSelectorOutput => {
            const banners: BannersTuples = [];

            const sortedZones = sortBy(
                zones,
                ({ attributes }) => attributes.index
            );

            sortedZones.forEach(zone => {
                const bannersConfig = bannerZone.get(zone.id)?.config;

                if (bannersConfig) {
                    banners.push([zone.id, bannersConfig]);
                }
            });

            return {
                zones,
                banners,
            };
        }
    );
};
